var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('Loading'):_vm._e()],1),_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }